// extracted by mini-css-extract-plugin
export default {"container":"Loading_container__z828X","loadingIcon":"Loading_loadingIcon__z3Y3o","spin":"Loading_spin__412wJ","txt":"Loading_txt__ZXPMK"};